module.exports = __webpack_public_path__ + "img/20190906155110410.9e35de4b.jpg";